var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.type
    ? _c(_vm.componentName, {
        key: _vm.route,
        tag: "component",
        attrs: { nid: parseInt(_vm.nid) },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }